<template>
    <div class="rader-chart" ref="wrapper">
    </div>
</template>


<script>
// グラフを重ねて描きたい場合はここらへん
// https://plot.ly/python/radar-chart/
import Plotly from 'plotly.js-dist';

export default {
    props: {
        values: null,
        labels: {
            required: true,
            validator: value => Array.isArray(value) && value.every(v => typeof v == 'string'),
        },
    },
    mounted() {
        const data = [{
            type: 'scatterpolar',
            r: [...this.values[0], this.values[0][0]],
            theta: [...this.labels, this.labels[0]],
            fill: 'toself'
        },
        {
            type: 'scatterpolar',
            r: [...this.values[1], this.values[1][0]],
            theta: [...this.labels, this.labels[0]],
            fill: 'toself'
        }]
        const layout = {
            polar: {
                radialaxis: {
                    visible: true,
                    range: [0, 6],
                }
            },
            showlegend: false,
        }
        Plotly.plot(this.$refs.wrapper, data, layout, {
            // displayModeBar: false, // 右上のツールバーを非表示
            staticPlot: true, // マウスで拡大できないように
        })
    },
    beforeDestroy() {
        Plotly.purge(this.$refs.wrapper)
    }
}
</script>
